// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__5-vxy","divider":"Sidebar_divider__2SXiv","bottomDivider":"Sidebar_bottomDivider__EXv0n"};